// "View on your wall" (AR) icon in the site's colours — a redraw of assets/ar.webp
// (phone over a panoramic picture) as inline SVG, so the colours follow the theme.
const ArIcon = ({ className, frame = "#4a3f30", accent = "#a8825c" }) => (
  <svg
    className={className}
    viewBox="0 0 512 512"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* Panorama wings behind the phone */}
    <path
      d="M112 138 C 58 144 22 156 22 178 V 446 C 22 458 46 466 72 470 V 214 C 84 210 98 208 112 207"
      stroke={frame}
      strokeWidth="26"
    />
    <path
      d="M400 138 C 454 144 490 156 490 178 V 446 C 490 458 466 466 440 470 V 214 C 428 210 414 208 400 207"
      stroke={frame}
      strokeWidth="26"
    />

    {/* Picture on the screen */}
    <path d="M126 132 Q 256 118 386 132" stroke={accent} strokeWidth="24" />
    <path d="M126 404 Q 256 390 386 404" stroke={accent} strokeWidth="24" />
    <circle cx="190" cy="208" r="25" stroke={accent} strokeWidth="24" />
    <path d="M128 352 L 196 276 L 232 316 L 296 246 L 384 336" stroke={accent} strokeWidth="24" />

    {/* Phone */}
    <rect x="112" y="28" width="288" height="456" rx="40" stroke={frame} strokeWidth="28" />
    <path d="M206 76 H 264" stroke={frame} strokeWidth="26" />
    <circle cx="306" cy="76" r="9" fill={frame} />
  </svg>
);

export default ArIcon;
